
import UserAvatar from './userAvatar.vue'

export default {
    name: 'UserListItem',
    props: {
        contractorId: {
            type: String,
            required: true,
        },
        user: {
            type: Object,
            required: true,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        UserAvatar,
    },
    computed: {
        contractorAssignment() {
            if (!Array.isArray(this.user?.contractorAssignments?.data)) {
                return null
            }

            return this.user.contractorAssignments.data.find(
                (assignment) => assignment?.contractor.data.id === this.contractorId
            )
        },
        assignmentRoles() {
            if (!this.contractorAssignment) {
                return []
            }

            return this.contractorAssignment.roleAssignments.data
                .map((assignment) => assignment.role.data.name)
                .filter(Boolean)
        },
        listeners() {
            let listeners: Record<string, any> = {}
            if (!this.readonly && this.$listeners.add) {
                listeners.click = this.$listeners.add
            }

            return listeners
        },
    },
}
